import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";
import { FieldInput } from "./FieldInput";

export const EntryDialog = ({ open, onClose, template, onSaved }) => {
  const [data, setData] = useState({});
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setData({}); }, [open]);
  const save = async () => {
    setBusy(true);
    try {
      await api.post(`/forms/templates/${template.template_id}/rows`, { data });
      toast.success("Entry added"); onSaved(); onClose();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="entry-dialog">
        <DialogHeader><DialogTitle>New entry · {template.name}</DialogTitle></DialogHeader>
        <div className="grid sm:grid-cols-2 gap-3">
          {template.fields.map((f) => (
            <div key={f.key} className={f.type === "textarea" ? "sm:col-span-2" : ""}>
              <label className="text-xs font-semibold text-slate-600">{f.label}{f.required && <span className="text-rose-600"> *</span>}</label>
              <FieldInput field={f} value={data[f.key]} onChange={(v) => setData({ ...data, [f.key]: v })} testid={`entry-field-${f.key}`} />
            </div>
          ))}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="entry-cancel">Cancel</Button>
          <Button onClick={save} disabled={busy} data-testid="entry-save">Save entry</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
